import React from 'react';
import { Typography, TypographyProps } from '@mui/material';

type Props = {
  children: React.ReactNode
} & TypographyProps;

function HelperText({ children, ...props }: Props) {
  return (
    <Typography
      {...props}
      variant="caption"
      sx={{ paddingLeft: '12px', color: '#A6A6BF' }}
      display="inline-block"
    >
      {children}
    </Typography>
  );
}

export default HelperText;
